module.exports = __webpack_public_path__ + "img/teepees-map--es.e5f272e8.png";